import * as React from 'react';
import React__default from 'react';

function createCommonjsModule(fn) {
  var module = { exports: {} };
	return fn(module, module.exports), module.exports;
}

var _extends_1 = createCommonjsModule(function (module) {
function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;
});

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var objectWithoutPropertiesLoose = _objectWithoutPropertiesLoose;

var _excluded = ["color", "size", "style"];
var Icon = (function (SvgComponent) {
  return /*#__PURE__*/React__default.forwardRef(function (props, ref) {
    var _props$color = props.color,
        color = _props$color === void 0 ? 'currentColor' : _props$color,
        _props$size = props.size,
        size = _props$size === void 0 ? '1em' : _props$size,
        _props$style = props.style,
        style = _props$style === void 0 ? {} : _props$style,
        otherProps = objectWithoutPropertiesLoose(props, _excluded);

    return /*#__PURE__*/React__default.createElement(SvgComponent, _extends_1({
      ref: ref,
      fill: color,
      width: size,
      height: size,
      style: _extends_1({}, style)
    }, otherProps));
  });
});

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M512 1024A512 512 0 0115.36 388.267 512 512 0 01950.613 248.32a508.16 508.16 0 0158.027 387.413A512 512 0 01512 1024zm0-998.4a486.4 486.4 0 00-117.76 958.293A486.4 486.4 0 00983.893 629.76 486.4 486.4 0 00629.76 40.107 488.96 488.96 0 00512 25.6zm-85.333 657.067v-285.44h-102.4v100.266c0 146.774-43.094 185.174-110.934 185.174h-32.426v-61.44H192c29.867 0 65.707-6.827 65.707-140.8V336.213h236.8v346.454zm308.053 0H564.053V336.213h165.974a93.013 93.013 0 01104.533 93.014 76.8 76.8 0 01-48.64 74.666 82.773 82.773 0 0153.76 81.067 93.867 93.867 0 01-104.96 97.707zm-20.48-291.414h-81.92v85.334h81.92c33.28 0 51.2-15.787 51.2-42.667s-18.347-42.667-51.2-42.667zm4.267 141.227h-85.334v95.573h85.334a48.213 48.213 0 100-95.573z"
});

function SvgBgn(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "BGN_svg__icon",
    width: 200,
    height: 200,
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _ref);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgn);

var ForwardIcon = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__default.createElement(ForwardRef, _extends_1({}, props, {
    ref: ref
  }));
});
var KuFoxIcons = Icon(ForwardIcon);
KuFoxIcons.displayName = 'BGNOutlined';

export default KuFoxIcons;
